export * from "./i18n-resources"